import type { Language } from './language';
import type { Translation } from './translation';
import { kk } from './kk';
import { ru } from './ru';

/**
 * Both languages are bundled rather than fetched: there are two of them and they are small, and a
 * language switch that has to wait on the network shows an untranslated flash on every navigation.
 */
export const TRANSLATIONS: Record<Language, Translation> = { kk, ru };
